import { useQuery } from '@tanstack/react-query'
import { fetchEvents, fetchRuns, fetchAgents, fetchAgent } from '../../lib/api'
import { useActiveWorkspace } from '../../lib/workspace'

export function useEvents(enabled = true) {
  return useQuery({
    queryKey: ['events'],
    queryFn: fetchEvents,
    refetchInterval: 1000,
    enabled,
  })
}

export function useRuns(enabled = true) {
  const { activeWorkspaceKey } = useActiveWorkspace()
  return useQuery({
    queryKey: ['runs', activeWorkspaceKey],
    queryFn: () => fetchRuns(activeWorkspaceKey),
    enabled: enabled && !!activeWorkspaceKey,
  })
}

export function useAgentsList(enabled = true) {
  const { activeWorkspaceKey } = useActiveWorkspace()
  return useQuery({
    queryKey: ['agents', activeWorkspaceKey],
    queryFn: () => fetchAgents(activeWorkspaceKey),
    enabled: enabled && !!activeWorkspaceKey,
  })
}

export function useAgent(name: string) {
  const { activeWorkspaceKey } = useActiveWorkspace()
  return useQuery({
    queryKey: ['agent', activeWorkspaceKey, name],
    queryFn: () => fetchAgent(activeWorkspaceKey, name),
    enabled: !!activeWorkspaceKey && !!name,
  })
}
